import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import {
  ProjectRepo,
  ProjectRepositoryUID,
} from "@radarly/core/project/repositories/ProjectRepo";
import { useCanAccessProject } from "@radarly/core/security/use-cases";

export function useCurrentProjectBootstrap(id: number) {
  const repository = useInjection<ProjectRepo>(ProjectRepositoryUID);
  const {
    data: project,
    isLoading: loading,
    error,
  } = useQuery(["/project/get", id], () => {
    return repository.getProject(id);
  });
  const canAccessProject = useCanAccessProject(project);
  return {
    loading,
    project,
    error: loading ? false : !!error || !canAccessProject,
  };
}
